module.exports = __webpack_public_path__ + "static/media/video-help-center.e28d56ea.svg";